import { useAuth0 } from "@auth0/auth0-react";
import {
  AnchorButton,
  Button,
  Colors,
  Icon,
  Menu,
  MenuItem,
  Navbar,
  Popover,
} from "@blueprintjs/core";
import { useAuthState } from "@package/ui-authentication";
import { useConfigState } from "@package/ui-config";
import type { PropsWithChildren } from "react";

type HeaderProps = {
  fullWidth: boolean;
};

function MenuProfile({ onLogOut }: { onLogOut: () => void }) {
  return (
    <Menu>
      <MenuItem icon="log-out" text="Log Out" onClick={() => onLogOut()} />
    </Menu>
  );
}

export function Header({
  fullWidth,
  children,
}: PropsWithChildren<HeaderProps>) {
  const { app, applications } = useConfigState();
  const { authorizedApps } = useAuthState();
  const { logout } = useAuth0();

  return (
    <div className="flex">
      <div className="grow">
        <Navbar className="flex bg-sky-800 justify-center text-white">
          <div className={`flex w-full ${fullWidth ? "" : "max-w-7xl"}`}>
            <Navbar.Group className="min-w-60">
              <h3 className="bp6-heading text-white mt-2">PanoScape</h3>
            </Navbar.Group>
            <Navbar.Group className="pl-4">
              {applications
                .filter((a) => authorizedApps.includes(a.key))
                .map(({ display, key, uri }) => (
                  <AnchorButton
                    key={key}
                    className="font-medium mr-2"
                    minimal
                    active={key === app}
                    text={display}
                    href={uri}
                    style={{ color: Colors.WHITE }}
                  />
                ))}
            </Navbar.Group>
            <Navbar.Group className="grow justify-end">
              {children}
              <Popover
                content={
                  <MenuProfile
                    onLogOut={() =>
                      logout({
                        logoutParams: {
                          returnTo: location.origin,
                        },
                      })
                    }
                  />
                }
                placement="bottom"
              >
                <Button title="Profile" minimal>
                  <Icon icon="user" style={{ color: Colors.WHITE }} />
                </Button>
              </Popover>
            </Navbar.Group>
          </div>
        </Navbar>
      </div>
    </div>
  );
}
